import * as MutationsTypes from './mutation-types';
import USER from '@/constants/user';
import {
  getUserDetails,
} from '@/api/user/index';

import { RootState } from '../types';
import { User } from './types';
import { ActionContext } from 'vuex';

interface ResponseDTO {
  username: string;
  id: number;
  name: string;
  email: string;
  authorities: [], 
  company: {
    name: string
    governmentId: string
    zipCode: string
    address: string
    phone: string
    trial: boolean
    analysisCount: number
    farmsCount: number,
    analitica: boolean,
    sentinela: boolean,
    uuid: string,
    clientDetails: {
      clientId?: string
    } | undefined
  }
}

export default {
  async [MutationsTypes.USER_REQUEST]({ commit }: ActionContext<User, RootState>) {
    commit(MutationsTypes.USER_REQUEST);

    return getUserDetails()
      .then(response => response.data)
      .then((content: ResponseDTO) => {
        const principalInfo = content;
        
        try {
          localStorage.setItem(USER.STORAGE_USERNAME, principalInfo.username);
          localStorage.setItem(USER.STORAGE_USER_ID, JSON.stringify(principalInfo.id));
          localStorage.setItem(USER.STORAGE_NAME, principalInfo.name);
          localStorage.setItem(USER.STORAGE_EMAIL, principalInfo.email);
          localStorage.setItem(USER.STORAGE_COMPANY_NAME, principalInfo.company.name);
          localStorage.setItem(USER.STORAGE_COMPANY_DOC, principalInfo.company.governmentId);
          localStorage.setItem(USER.STORAGE_COMPANY_ZIPCODE, principalInfo.company.zipCode);
          localStorage.setItem(USER.STORAGE_COMPANY_ADDRESS, principalInfo.company.address);
          localStorage.setItem(USER.STORAGE_COMPANY_PHONE, principalInfo.company.phone);
          localStorage.setItem(USER.STORAGE_COMPANY_TRIAL, JSON.stringify(principalInfo.company.trial));
          localStorage.setItem(USER.STORAGE_COMPANY_ANALYSIS_COUNT, JSON.stringify(principalInfo.company.analysisCount));
          localStorage.setItem(USER.STORAGE_COMPANY_FARMS_COUNT, JSON.stringify(principalInfo.company.farmsCount));
          localStorage.setItem(USER.STORAGE_COMPANY_ANALITICA, JSON.stringify(principalInfo.company.analitica));
          localStorage.setItem(USER.STORAGE_COMPANY_SENTINELA, JSON.stringify(principalInfo.company.sentinela));
          localStorage.setItem(USER.STORAGE_COMPANY_ID, JSON.stringify(principalInfo.company.uuid));
          localStorage.setItem(USER.STORAGE_COMPANY_CLIENT_ID, JSON.stringify(principalInfo.company.clientDetails?.clientId ?? null));
          localStorage.setItem(USER.STORAGE_AUTHORITIES, JSON.stringify(principalInfo.authorities));
        } finally {
          commit(MutationsTypes.USER_SUCCESS, {
            username: principalInfo.username,
            userId: principalInfo.id,
            name: principalInfo.name,
            email: principalInfo.email,
            companyName: principalInfo.company.name,
            companyDoc: principalInfo.company.governmentId,
            companyZipCode: principalInfo.company.zipCode,
            companyAddress: principalInfo.company.address,
            companyPhone: principalInfo.company.phone,
            companyTrial: principalInfo.company.trial,
            companyAnalysisCount: principalInfo.company.analysisCount,
            companyFarmsCount: principalInfo.company.farmsCount,
            companyAnalitica: principalInfo.company.analitica,
            companySentinela: principalInfo.company.sentinela,
            companyId: principalInfo.company.uuid,
            companyClientId: principalInfo.company.clientDetails?.clientId ?? null,
            authorities: principalInfo.authorities,
          });
        }
      })
      .catch(() => {
        localStorage.removeItem(USER.STORAGE_USERNAME);
        localStorage.removeItem(USER.STORAGE_USER_ID);
        localStorage.removeItem(USER.STORAGE_NAME);
        localStorage.removeItem(USER.STORAGE_EMAIL);
        localStorage.removeItem(USER.STORAGE_COMPANY_NAME);
        localStorage.removeItem(USER.STORAGE_COMPANY_DOC);
        localStorage.removeItem(USER.STORAGE_COMPANY_ZIPCODE);
        localStorage.removeItem(USER.STORAGE_COMPANY_ADDRESS);
        localStorage.removeItem(USER.STORAGE_COMPANY_PHONE);
        localStorage.removeItem(USER.STORAGE_COMPANY_TRIAL);
        localStorage.removeItem(USER.STORAGE_COMPANY_ANALYSIS_COUNT);
        localStorage.removeItem(USER.STORAGE_COMPANY_FARMS_COUNT);
        localStorage.removeItem(USER.STORAGE_COMPANY_ANALITICA);
        localStorage.removeItem(USER.STORAGE_COMPANY_SENTINELA);
        localStorage.removeItem(USER.STORAGE_COMPANY_ID);
        localStorage.removeItem(USER.STORAGE_COMPANY_CLIENT_ID);
        localStorage.removeItem(USER.STORAGE_AUTHORITIES);

        commit(MutationsTypes.USER_ERROR);
      });
  },
  [MutationsTypes.USER_LOGOUT]({ commit }: ActionContext<User, RootState>) {
    localStorage.removeItem(USER.STORAGE_USERNAME);
    localStorage.removeItem(USER.STORAGE_USER_ID);
    localStorage.removeItem(USER.STORAGE_NAME);
    localStorage.removeItem(USER.STORAGE_EMAIL);
    localStorage.removeItem(USER.STORAGE_COMPANY_NAME);
    localStorage.removeItem(USER.STORAGE_COMPANY_DOC);
    localStorage.removeItem(USER.STORAGE_COMPANY_ZIPCODE);
    localStorage.removeItem(USER.STORAGE_COMPANY_ADDRESS);
    localStorage.removeItem(USER.STORAGE_COMPANY_PHONE);
    localStorage.removeItem(USER.STORAGE_COMPANY_TRIAL);
    localStorage.removeItem(USER.STORAGE_COMPANY_ANALYSIS_COUNT);
    localStorage.removeItem(USER.STORAGE_COMPANY_FARMS_COUNT);
    localStorage.removeItem(USER.STORAGE_COMPANY_ANALITICA);
    localStorage.removeItem(USER.STORAGE_COMPANY_SENTINELA);
    localStorage.removeItem(USER.STORAGE_COMPANY_ID);
    localStorage.removeItem(USER.STORAGE_COMPANY_CLIENT_ID);
    localStorage.removeItem(USER.STORAGE_AUTHORITIES);

    commit(MutationsTypes.USER_LOGOUT);

    return Promise.resolve();
  },
};
